import React, { useEffect, useState } from 'react'
import {
  Box, Container, Stack, Tooltip, Typography, Pagination,
  Link, Button,
  Modal,
  SwipeableDrawer,
} from '@mui/material'
import * as API from '../../../utils/APICalls'
import * as helpers from '../../../utils/helpers'
import { DataGrid } from '@mui/x-data-grid'
import EventDetailsModal from './EventDetailsModal'
import ReviewEventModal from '../../../components/ReviewEventModal'
import BookingForm from './BookingForm'
import CloseButton from '../../../components/CloseButton'

const Events = ({ artist, view }) => {
  const [eventList, setEventList] = useState()
  const [reviewEventModalOpen, setReviewEventModalOpen] = useState(false)
  const [eventDetailModalOpen, setEventDetailModalOpen] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState({})
  const [showBookingForm, setShowBookingForm] = useState(false)

  const handleViewEventClick = async (row) => {
    // Perform action with the row data
    // window.open(row?.location?.url,'_blank')
    if (view === 'console') {
      setSelectedEvent(row)
      setReviewEventModalOpen(true)
      try {
        const res = await API.updateBooking({ ...row, isReviewed: true, status: 'reviewed' })
      } catch (err) { console.log('Error updating event status', err) }
    } else {

      setSelectedEvent(row)
      setEventDetailModalOpen(true)
    }
  };
  const BtnStatusColor = (row) => {
    let color = 'primary'
    if (view !== 'console') {
      return color
    } else {
      if (!row?.isReviewed) {
        color = 'error'
      }
      else if (row?.isConfirmed) {
        color = 'success'
      }
      else {
        color = 'secondary'
      }
    }

    return color
  }
  const bookingColumns = [
    {
      field: 'location.url',
      headerName: 'view',
      width: 80,
      // editable: true,
      renderCell: (params) => {
        // if (!params.row?.location?.url) {
        return (
          <Button
            variant="contained"
            color={BtnStatusColor(params.row)}
            size="small"
            // disabled={!params.row?.location?.url}
            onClick={() => handleViewEventClick(params.row)}
          >
            view
          </Button>
        );
        // } 

      },
    },
    {
      field: 'date',
      headerName: 'Date',
      width: 80,
      renderCell: (params) => {
        return helpers.formatedEventDate(params.row?.date)
      }
    },
    {
      field: 'location.venue', headerName: 'Venue', width: 90,
      renderCell: (params) => {
        return params.row?.location?.venue
      }

    },
    {
      field: 'location.city', headerName: 'City', width: 100,
      renderCell: (params) => {
        return `${params.row?.location?.city}, ${params.row?.location?.state}`
      }

    },
    // { field: 'event_name', headerName: 'Event', width: 90 },
    {
      field: 'event_time',
      headerName: 'Time',
      width: 60,
      renderCell: (params) => {
        return helpers.convertMilitaryToAmPm(params.row?.event_time)
      }
    },
    {
      field: 'door_age',
      headerName: 'Age',
      width: 65,
      // editable: true,
    },
    {
      field: 'price',
      headerName: 'Price',
      width: 70,
      // editable: true,
      renderCell: (params) => {
        const adv = params.row?.price?.adv?.toLowerCase()
        const door = params.row?.price?.door?.toLowerCase()
        const priceString = adv !== door ? `$${adv ? adv + ' / ' : ''}${door ? door : ''}` : `$${adv}`
        let response = 'TBA'
        if ((adv === '0' && door === '0') || adv && door === 'free') {
          response = 'Free'
        }
        if (adv || door) {
          response = priceString
        }
        return response
      }

    },

  ];
  const fetchBookings = async () => {
    try {
      const bookings = await API.fetchBookings(artist?._id)
      const confirmedBookings = bookings.map((b, i) => {
        if (view === 'console') {
          return b
        } else {
          if (b?.isConfirmed) return b
        }
      })
      if (confirmedBookings?.length > 0) {
        setEventList(confirmedBookings)
      }
    } catch (err) {
      console.log('Error Fetching Bookings', err)
    }
  }

  useEffect(() => {

    fetchBookings()
  }, [])
  useEffect(() => {
    console.log('eventList:', eventList)
  }, [eventList])
  useEffect(() => {

  }, [selectedEvent, eventDetailModalOpen])
  return (
    <Container
      sx={{
        padding: '0.5rem', width: '100%', height: '100%', minHeight: '400px',
        color: '#000',
        backgroundColor: '#FFF',
        border: view === 'console' ? 'none' : '1px solid #000',
        borderRadius: '5px',
        justifyContent: 'center', overflow: 'hidden', overflowY: 'scroll',
        marginTop: '2.5rem',

      }}>
      <Stack

        sx={{ position: 'relative', gap: '0.5rem', width: '95%' }}>

        {view === 'console' && <Box sx={{ position: 'absolute', right: '0.5rem', top: '0.5rem' }}>
          <Button variant='contained'
            onClick={() => {
              setShowBookingForm(true)
            }}
          >+</Button>
          <SwipeableDrawer
            onTouchStart={event => {
              event.nativeEvent.defaultMuiPrevented = true
            }}
            anchor={'bottom'}
            open={showBookingForm}
            onClose={() => { setShowBookingForm(false) }}
          >
            <Box sx={{ position: 'absolute', top: '0.5rem', right: '0.5rem' }}>
              <CloseButton func={setShowBookingForm} val={showBookingForm}
              />
            </Box>
            <BookingForm
              artist={artist}
              setShowDrawer={showBookingForm}
              view={view}
            />
          </SwipeableDrawer>
        </Box>}
        <b>Events</b>
        {view === 'console' && <Box sx={{
          display: 'flex', padding: '0.5rem',
          width: '100%',
          margin: 'auto',
          gap: '0.5rem',
          justifyContent: 'center',
          fontWeight: 'normal',
          fontSize: '0.7rem'
        }}>
          <Box sx={{ display: 'flex', padding: '0.5rem', borderRight: '1px solid #000' }}>
            <Box sx={{
              width: '0.75rem',
              height: '0.75rem',
              borderRadius: '5px',
              border: '1px solid #000',
              backgroundColor: 'red',
            }}>&nbsp;</Box>&nbsp;
            - new
          </Box>
          <Box sx={{ display: 'flex', padding: '0.5rem', borderRight: '1px solid #000' }}>
            <Box sx={{
              width: '0.75rem',
              height: '0.75rem',
              borderRadius: '5px',
              border: '1px solid #000',
              backgroundColor: 'purple',
            }}>&nbsp;</Box>&nbsp;
            - pending
          </Box>
          <Box sx={{ display: 'flex', padding: '0.5rem', }}>
            <Box sx={{
              width: '0.75rem',
              height: '0.75rem',
              borderRadius: '5px',
              border: '1px solid #000',
              backgroundColor: 'green',
            }}>&nbsp;</Box>&nbsp;
            - confirmed
          </Box>
        </Box>}
        {/* <Box         
                  
    sx={{
                  display:'flex', flexDirection: 'row', gap :'0.5rem',
                  width:'100%', margin:'auto', marginTop:'2rem', 
                 padding:'0.5rem', minHeight:'200px',
                 border:'1px solid #000', borderRadius:'5px',
                  boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)'
                }}> */}
        {/* {eventList?.length >0 ? eventList?.map((s,i)=>{
                            return(
                              <Stack>
                                {s?.event_name}
                              </Stack>
                            )
                        }):<Stack sx={{margin:'auto', gap:'0.5rem',textAlign:'center'}}>
                          <span> No Events Listed.</span>
                          <em style={{fontSize:'0.75  rem'}}>( You can change that by heading to booking though! )</em></Stack>} */}

        {eventList?.length > 0 ?
          <DataGrid
            rows={eventList}
            columns={bookingColumns}
            // getRowId={(row) => row?._id}
            getRowId={(row) => eventList?.indexOf(row)}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                  // color:'#00ff00'
                },
              },
            }}
            components={{
              Pagination: (props) => (
                <Pagination {...props} className="custom-pagination" />
              ),
            }}
            // getRowClassName={() => 'share-row-text-color'}
            pageSizeOptions={[5]}
            // checkboxSelection
            disableRowSelectionOnClick
            sx={{
              width: '100%',
              padding: '0.5rem',
              border: '1px solid #000', borderRadius: '5px',
              boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)',
              '& .MuiTablePagination-root': {
                color: '#FF00FF', // Main text color
              },
              // '& .MuiTablePagination-selectLabel': {
              //     color: '#00ff00', // "Rows per page" label color
              // },
              // '& .MuiTablePagination-select': {
              //     color: '#00FF00', // Dropdown text color
              // },
              // '& .MuiTablePagination-displayedRows': {
              //     color: '#FF00FF', // Displayed rows text color
              // },
            }}
          /> : <Stack sx={{ margin: 'auto', gap: '0.5rem', textAlign: 'center' }}>
            <span> No Events Listed.</span>
            <em style={{ fontSize: '0.75rem' }}>( You can change that by heading to booking though! )</em></Stack>}
        {/* </Box> */}

      </Stack>
      <EventDetailsModal
        event={selectedEvent}
        eventDetailModalOpen={eventDetailModalOpen}
        setEventDetailModalOpen={setEventDetailModalOpen} />

      <ReviewEventModal
        selectedEvent={selectedEvent}
        setSelectedEvent={setSelectedEvent}
        reviewEventModalOpen={reviewEventModalOpen}
        setReviewEventModalOpen={setReviewEventModalOpen}
        fetchBookings={fetchBookings}
      />

    </Container>
  )
}

export default Events